// NoticeAgreeModal.jsx
import React, { useMemo, useState, useEffect } from "react";
import ReactModal from "react-modal";

const PRECAUTIONS = [
  "교육생 본인 명의(실명)로 신청 및 결제해야 하며, 타인 명의 결제나 대리 신청은 제한됩니다.",
  "본 과정은 법정 집체교육으로, 전체 교육시간을 100% 이수(지각·조퇴 포함 시 미수료)해야 수료 처리됩니다.",
  "신청 마감 이후부터 교육 당일 출석확인 전까지는 환불이 불가합니다. (마감 전 취소 시 전액 환불, 카드사 정책에 따라 환급 시점이 지연될 수 있습니다.)",
  "원활한 진행을 위해 교육 시작 10분 전까지 입실하고, 신분증을 지참하여 본인 확인에 협조해 주세요.",
  "교육 이수 처리 및 증명서 발급을 위해 개인정보(성명, 연락처, 소속 등)의 수집·이용 및 관련 기관/운영사에 대한 제공에 동의합니다."
];

export function NoticeAgreeModal({ isOpen, onClose, onConfirm }) {
  // ✅ LectureStudent 패턴: 선택된 항목 인덱스 배열
  const [selectedIdx, setSelectedIdx] = useState([]);

  useEffect(() => {
    if (isOpen) {
      setSelectedIdx([]);
      // 선택적으로: 모달 열릴 때 스크롤 맨 위로
      // document.querySelector('.ReactModal__Content')?.scrollTo(0, 0);
    }
  }, [isOpen]);

  const isAllChecked = useMemo(
    () => selectedIdx.length === PRECAUTIONS.length && PRECAUTIONS.length > 0,
    [selectedIdx.length]
  );

  const handleSelectItem = (idx) => {
    setSelectedIdx((prev) =>
      prev.includes(idx) ? prev.filter((i) => i !== idx) : [...prev, idx]
    );
  };

  const handleSelectAll = () => {
    if (isAllChecked) {
      setSelectedIdx([]);
    } else {
      setSelectedIdx(PRECAUTIONS.map((_, i) => i));
    }
  };

  const handleConfirm = () => {
    if (!isAllChecked) {
      alert("모든 항목을 체크해주세요");
      return;
    }
    onConfirm();   // 부모에서 ModalUser 오픈
    onClose();     // 본 팝업 닫기
    setSelectedIdx([]); // 다음 오픈 시 초기화
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      ariaHideApp={false}
      overlayClassName="modal-overlay"
      style={{
        content: {
          maxWidth: "720px",
          inset: "10% auto auto 50%",
          transform: "translateX(-50%)",
          padding: 0
        }
      }}
    >
      {/* 헤더 */}
      <div className="modal-header">
        <h3 className="tit-T" style={{ margin: 0 }}>유의사항 안내</h3>
      </div>

      {/* 바디 */}
      <div className="modal-body">
        {/* 상단 안내 + 전체동의 제어 */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
            marginBottom: 16
          }}
        >
          <p style={{ margin: 0, fontWeight: 600 }}>
            집체교육 관련 유의사항을 확인한 다음 신청 진행해 주시기 바랍니다.
          </p>

          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            {/* 전체동의 체크박스 (LectureStudent 패턴) */}
            <label style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
              <input
                type="checkbox"
                checked={isAllChecked}
                onChange={handleSelectAll}
              />
              전체동의
            </label>
           
          </div>
        </div>

        {/* 항목 리스트 (div 레이아웃) */}
        <div>
          {PRECAUTIONS.map((text, i) => (
            <div
              key={i}
              className="box-border"
              style={{
                display: "flex",
                alignItems: "flex-start",
                padding: "14px 16px",      // 간격 넓게
                marginBottom: 14,          // 간격 넓게
                gap: 14,                   // 간격 넓게
                border: "none",            // 테두리 숨김
                boxShadow: "none",         // 그림자 숨김
                background: "transparent"  // 배경 투명
              }}
            >
              {/* 번호 */}
              <div style={{ width: 24, textAlign: "center", lineHeight: "28px" }}>
                {i + 1}
              </div>

              {/* 본문 */}
              <div style={{ flex: 1, lineHeight: 1.7 }}>
                {text}
              </div>

              {/* 체크박스 (항목 우측) */}
              <div style={{ lineHeight: 1.4 }}>
                <input
                  type="checkbox"
                  name={`agree_${i}`}
                  checked={selectedIdx.includes(i)}
                  onChange={() => handleSelectItem(i)}
                  style={{ marginTop: 4 }}
                />
              </div>
            </div>
          ))}
        </div>

        <p className="txt-red small-font" style={{ marginTop: 8 }}>
          * 모든 항목을 확인해야 다음 단계로 진행됩니다.
        </p>
      </div>

      {/* 푸터: 중앙 정렬 */}
      <div
        className="modal-footer text-cent"
        style={{
          marginTop: 12,
          display: "flex",
          justifyContent: "center",
          gap: 10
        }}
      >
        <button className="btn btn_blue" onClick={onClose}>닫기</button>
        <button className="btn btn_red" onClick={handleConfirm}>확인</button>
      </div>
    </ReactModal>
  );
}
